import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Next render me fallback UI show kare
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Yahan logs bhejo: Sentry, LogRocket, console
    console.error("ErrorBoundary caught an error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="alert alert-danger p-3 m-3">
          <h5>Something went wrong.</h5>
          <p>{this.state.error?.message || "Unexpected error occurred."}</p>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
